import { isLinkRequired, LINK_REQUIRED_MESSAGE } from '@/utils/member-split/link-required';

/**
 * The one message a failed `PUT /v2/profile` shows. The store says nothing itself, so
 * each caller shows this: the app's waiting copy for a login its leader has not linked,
 * else the API's own text (a validation array joined), else the caller's fallback.
 */
export function profileSaveErrorMessage(error, fallback) {
  if (isLinkRequired(error)) return LINK_REQUIRED_MESSAGE;
  const message = error?.response?.data?.message;
  const text = Array.isArray(message) ? message.join(', ') : message;
  return typeof text === 'string' && text.trim() ? text : fallback;
}
